export default __webpack_public_path__ + "static/media/icon-forgot-password-success.d270a573.svg";